<div class="tw:flex tw:items-center tw:justify-around tw:p-2">
  <div class="tw:w-12 tw:font-bold">{{ value }}</div>
  <div>
    <ion-button size="small" (click)="decrease()">
      <ion-icon color="light" slot="start" name="remove-circle-outline"></ion-icon>
      Decrease
    </ion-button>
  </div>
  <div>
    <ion-button size="small" (click)="increase()">
      Increase
      <ion-icon slot="end" name="add-circle-outline"></ion-icon>
    </ion-button>
  </div>
</div>
